class AssetSummaryViewModel {
  constructor(data = {}) {
    this.assetId = data.assetId || null;
    this.modelVersionId = data.modelVersionId || null;
    this.modelVersionName = data.modelVersionName || null;
    this.modelVersionNumber = data.modelVersionNumber ?? null;
    this.scanCount = data.scanCount || 0;
    this.totalAnomalies = data.totalAnomalies || 0;
    this.totalAnomaliesPending = data.totalAnomaliesPending || 0;
    this.totalHotSpots = data.totalHotSpots || 0;
  }
}

export default AssetSummaryViewModel;